module.exports = __webpack_public_path__ + "ef718652b323ab6f395a6c60806471bc.fbx";